import React, { useState, useEffect } from 'react';
import { IconButton, TextField } from '@mui/material';
import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import InputAdornment from '@mui/material/InputAdornment';

export type Props = {
  onTextChange: (searchText: string) => void;
  value?: string;
  fullWidth?: boolean;
}

const ZerpaSearch: React.FC<Props> = ({
  onTextChange,
  value: defaultValue = '',
  fullWidth: fw,
}: Props) => {
  const [searchText, setSearchText] = useState<string>(defaultValue);

  useEffect(() => {
    const debounce = setTimeout(() => {
      onTextChange(searchText);
    }, 700);
    return () => clearTimeout(debounce);
  }, [searchText, onTextChange]);

  const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setSearchText(text);
  };

  const onSearchClear = () => {
    setSearchText('');
  };

  return (
    <>
      <TextField
        size="small"
        variant="outlined"
        value={searchText}
        onChange={onSearchTextChange}
        placeholder="Search…"
        fullWidth={fw}
        InputProps={{
          'aria-label': 'search',
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={onSearchClear} size="small">
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};

export default ZerpaSearch;
